__turbopack_context__.v({
  "monthItem": "TimelineItem-module__VoXXBq__monthItem",
  "monthLink": "TimelineItem-module__VoXXBq__monthLink",
  "monthsList": "TimelineItem-module__VoXXBq__monthsList",
  "monthsListOpen": "TimelineItem-module__VoXXBq__monthsListOpen",
  "yearButton": "TimelineItem-module__VoXXBq__yearButton",
  "yearItem": "TimelineItem-module__VoXXBq__yearItem",
});
